// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAa5ty5rSV9fYqDTMInKaNtVqQ8BjZsw20",
    authDomain: "make-webiste.firebaseapp.com",
    projectId: "make-webiste",
    storageBucket: "make-webiste.firebasestorage.app",
    messagingSenderId: "54398908760",
    appId: "1:54398908760:web:78abab3ba89b2755f78d2d",
    measurementId: "G-YZRN1PJGXY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);